// 静谧主题

import { useMemo } from 'react';
import { theme } from 'antd';

const useSereneTheme = () => {
  return useMemo(
    () => ({
      theme: {
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#312721',
          colorSuccess: '#49795d',
          colorWarning: '#cc9433',
          colorError: '#be4237',
          colorInfo: '#507395',
          colorTextBase: '#2a231d',
          colorBgBase: '#f8f6f2',
          colorPrimaryBg: '#f3efe8',
          colorPrimaryBgHover: '#ebe7e0',
          colorPrimaryBorder: '#d9d0c6',
          colorPrimaryBorderHover: '#c7a56b',
          colorPrimaryHover: '#3f342d',
          colorPrimaryActive: '#221c18',
          colorPrimaryText: '#312721',
          colorPrimaryTextHover: '#3f342d',
          colorPrimaryTextActive: '#221c18',
          colorSuccessBg: '#eef5f0',
          colorSuccessBgHover: '#e0ebe4',
          colorSuccessBorder: '#b8d4c3',
          colorSuccessBorderHover: '#8fb9a0',
          colorSuccessHover: '#3d6a4f',
          colorSuccessActive: '#335a43',
          colorSuccessText: '#49795d',
          colorSuccessTextHover: '#3d6a4f',
          colorSuccessTextActive: '#335a43',
          colorWarningBg: '#faf5eb',
          colorWarningBgHover: '#f3e8d4',
          colorWarningBorder: '#e8d4a8',
          colorWarningBorderHover: '#d9bc7a',
          colorWarningHover: '#b87f2a',
          colorWarningActive: '#9a6922',
          colorWarningText: '#cc9433',
          colorWarningTextHover: '#b87f2a',
          colorWarningTextActive: '#9a6922',
          colorErrorBg: '#faf0ee',
          colorErrorBgHover: '#f5e0dc',
          colorErrorBorder: '#e8b5ae',
          colorErrorBorderHover: '#d98f84',
          colorErrorHover: '#a8382f',
          colorErrorActive: '#8f2f27',
          colorErrorText: '#be4237',
          colorErrorTextHover: '#a8382f',
          colorErrorTextActive: '#8f2f27',
          colorInfoBg: '#eef2f6',
          colorInfoBgHover: '#e0e8ef',
          colorInfoBorder: '#b8c9d9',
          colorInfoBorderHover: '#8fa8be',
          colorInfoHover: '#426178',
          colorInfoActive: '#365263',
          colorInfoText: '#507395',
          colorInfoTextHover: '#426178',
          colorInfoTextActive: '#365263',
          colorText: '#2a231d',
          colorTextSecondary: '#766a60',
          colorTextTertiary: '#9a8f84',
          colorTextQuaternary: '#c4bab0',
          colorTextDisabled: '#c4bab0',
          colorBgContainer: '#fcfaf8',
          colorBgElevated: '#fcfaf8',
          colorBgLayout: '#f8f6f2',
          colorBgSpotlight: 'rgba(42, 35, 29, 0.85)',
          colorBgMask: 'rgba(42, 35, 29, 0.45)',
          colorBorder: '#e2dcd5',
          colorBorderSecondary: '#eeebe7',
          fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
          fontSize: 14,
          lineHeight: 1.6,
          borderRadius: 4,
          borderRadiusXS: 2,
          borderRadiusSM: 4,
          borderRadiusLG: 6,
          padding: 16,
          paddingSM: 12,
          paddingLG: 24,
          margin: 16,
          marginSM: 12,
          marginLG: 24,
          boxShadow: '0 1px 2px rgba(42, 35, 29, 0.04), 0 8px 24px -12px rgba(42, 35, 29, 0.08)',
          boxShadowSecondary:
            '0 2px 4px rgba(42, 35, 29, 0.05), 0 24px 48px -16px rgba(42, 35, 29, 0.14)',
          motionDurationMid: '0.3s',
          motionEaseInOut: 'ease',
        },
        components: {
          Button: {
            primaryShadow: 'none',
            defaultShadow: 'none',
            dangerShadow: 'none',
            defaultBorderColor: '#e2dcd5',
            defaultColor: '#2a231d',
            defaultBg: '#fcfaf8',
            defaultHoverBg: '#f8f6f2',
            defaultHoverBorderColor: '#d9d0c6',
            defaultHoverColor: '#2a231d',
            defaultActiveBg: '#ebe7e0',
            defaultActiveBorderColor: '#d9d0c6',
            borderRadius: 4,
            fontWeight: 500,
          },
          Input: {
            activeShadow: 'none',
            hoverBorderColor: '#c7a56b',
            activeBorderColor: '#312721',
            borderRadius: 4,
            colorBgContainer: '#fcfaf8',
          },
          Select: {
            optionSelectedBg: '#f3efe8',
            optionActiveBg: '#f8f6f2',
            optionSelectedFontWeight: 500,
            borderRadius: 4,
          },
          Layout: {
            bodyBg: '#f8f6f2',
            footerBg: '#f8f6f2',
            headerBg: '#fcfaf8',
            headerColor: '#2a231d',
            siderBg: '#2c241c',
            lightSiderBg: '#2c241c',
            triggerBg: '#3c332a',
            triggerColor: '#e8e2d9',
          },
          Menu: {
            activeBarWidth: 0,
            activeBarBorderWidth: 0,
            itemBg: 'transparent',
            subMenuItemBg: 'transparent',
            itemColor: 'rgba(232, 226, 217, 0.7)',
            itemHoverColor: '#e8e2d9',
            itemSelectedColor: '#ebe4d8',
            itemHoverBg: 'rgba(60, 51, 42, 0.4)',
            itemSelectedBg: '#3c332a',
            itemBorderRadius: 0,
            itemMarginInline: 12,
            itemHeight: 40,
          },
          Card: {
            borderRadiusLG: 4,
          },
          Modal: {
            borderRadiusLG: 6,
          },
          Alert: {
            borderRadiusLG: 4,
          },
          Progress: {
            circleTextColor: '#2a231d',
            defaultColor: '#312721',
            remainingColor: 'rgba(49, 39, 33, 0.08)',
          },
          Switch: {
            trackHeight: 22,
            trackMinWidth: 44,
          },
          Checkbox: {
            borderRadiusSM: 2,
          },
          Slider: {
            trackBg: '#ebe7e0',
            trackHoverBg: '#e2dcd5',
            handleColor: '#c7a56b',
            railSize: 4,
          },
          Notification: {
            colorSuccessBg: '#eef5f0',
            colorErrorBg: '#faf0ee',
            colorInfoBg: '#eef2f6',
            colorWarningBg: '#faf5eb',
          },
          Table: {
            headerBg: '#f3efe8',
            headerColor: '#766a60',
            borderColor: '#e2dcd5',
          },
        },
      },
    }),
    [],
  );
};

export default useSereneTheme;
